import TableChart from '@material-ui/icons/TableChart';
import { CSVLink } from 'react-csv';

import { ficheFields } from '../utils/constants';

// Fonction helper pour déterminer la bonne clé de champs pour le bobinage
const getBobinageFieldKey = (fiche) => {
  if (fiche.type === 4) {
    // Type Bobinage
    if (fiche.subtype === 1) {
      return 4; // Courant Alternatif
    } else if (fiche.subtype === 2) {
      return 41; // Courant Continu
    }
  }
  return fiche.type;
};

export function GenerateCsv({ fiche, fetchedData }) {
  const fields = [];

  // Boucle sur tous les types de fiches
  Object.keys(ficheFields).map((typeFiche) => {
    const typeInt = parseInt(typeFiche);

    // Déterminer si ce fieldset doit être inclus
    const shouldInclude =
      typeInt === 0 || // Informations générales
      (typeInt !== 4 && typeInt !== 41 && typeInt === parseInt(fiche.type)) ||
      (parseInt(fiche.type) === 2 &&
        parseInt(fiche.subtype) === typeInt - 20) || // Démontage
      (parseInt(fiche.type) === 3 &&
        parseInt(fiche.subtype) === typeInt - 30) || // Remontage
      (parseInt(fiche.type) === 4 &&
        parseInt(fiche.subtype) !== 2 &&
        typeInt === 4) || // Courant Alternatif
      (parseInt(fiche.type) === 4 &&
        parseInt(fiche.subtype) === 2 &&
        typeInt === 41) || // Courant Continu
      (typeInt === 42 && fiche.collecteur === true); // Collecteur

    if (shouldInclude) {
      // Afficher l'entête du groupe de champs
      fields.push([ficheFields[typeFiche].title, '']);
      fields.push(['', '']);

      // Pour tous les champs contenus dans ce groupe
      Object.keys(ficheFields[typeFiche].fields).map((f) => {
        const field = ficheFields[typeFiche].fields[f];

        // Pour la fiche de démontage de pompe, on n'utilise que les champs décrits ci-dessous
        if (
          parseInt(fiche.type) === 2 &&
          parseInt(fiche.subtype) === 1 &&
          parseInt(typeFiche) === 2 &&
          !['subtype', 'marque', 'typeMoteur', 'numSerie'].includes(f)
        ) {
          return false;
        }

        // Si le champ n'est pas rempli dans la fiche, on ne l'affiche pas
        if (
          (Array.isArray(fiche[f]) && fiche[f].length === 0) ||
          !fiche.hasOwnProperty(f) ||
          fiche[f] === '' ||
          fiche[f] === null ||
          fiche[f] === undefined
        ) {
          return false;
        }

        switch (field.type) {
          case 'select':
            let val;
            if (field.values) {
              val = field.values.find(
                (v) => v.value.toString() === fiche[f]?.toString()
              )?.label;
            } else if (field.data) {
              if (field.multiple) {
                if (fiche[f]) {
                  val = fiche[f].map(
                    (v1) =>
                      fetchedData[field.data].find((v2) => v2.value === v1)
                        ?.label
                  );
                }
              } else {
                val = fetchedData[field.data].find(
                  (v) => v.value === fiche[f]
                )?.label;
              }
            }
            return fields.push([
              field.label,
              field.multiple ? val?.join(', ') : val,
            ]);

          case 'array':
            if (field.subtype === 'object') {
              return fiche[f]
                .map((v1) =>
                  Object.keys(field.values)
                    .map((v2) => {
                      return `${field.values[v2].label}: ${v1[v2] || 'N/A'}`;
                    })
                    .join(', ')
                )
                .map((res) => fields.push([field.label, res]));
            }
            return fields.push([field.label, fiche[f].join(', ')]);

          case 'radio':
            return fields.push([
              field.label,
              field.options
                ? field.options.find(
                    (o) => o.value.toString() === fiche[f]?.toString()
                  )?.label
                : fiche[f] === true || fiche[f] === 'true'
                ? 'Oui'
                : 'Non',
            ]);

          case 'number':
            return fields.push([
              field.label,
              `${fiche[f]}${field.unit ? ' ' + field.unit : ''}`,
            ]);

          default:
            return fields.push([
              field.label,
              `${fiche[f]}${field.unit ? ' ' + field.unit : ''}`,
            ]);
        }
      });

      fields.push(['', '']);
      fields.push(['', '']);
    }
    return false;
  });

  return (
    <CSVLink
      data={fields}
      filename={`${fiche.numFiche}.csv`}
      separator=";"
      className="bg-viguierBleu flex items-center justify-center py-1 px-2 rounded hover:text-viguierJaune hover:bg-viguierBleuFoncé cursor-pointer"
    >
      <div className="mr-2 text-xs lg:text-base">
        Exporter les données au format CSV
      </div>
      <TableChart />
    </CSVLink>
  );
}
